module.exports = require("react-select/lib/Async");